(() => {
  if (!document.body.classList.contains('template-index')) return;

  const selectors = '#MainContent img, .shopify-section-group-footer-group img, footer img';

  const decodeImage = (img) => {
    if (!img?.src) return Promise.resolve();

    if (img.loading === 'lazy') {
      img.loading = 'eager';
    }

    if (img.complete && img.naturalWidth > 0) {
      return img.decode ? img.decode().catch(() => {}) : Promise.resolve();
    }

    return new Promise((resolve) => {
      const preload = new Image();
      preload.src = img.currentSrc || img.src;
      if (img.srcset) preload.srcset = img.srcset;
      if (img.sizes) preload.sizes = img.sizes;

      const done = () => resolve();
      if (preload.decode) {
        preload.decode().then(done).catch(done);
      } else {
        preload.onload = done;
        preload.onerror = done;
      }
    });
  };

  const preloadHomepageImages = () => {
    const images = document.querySelectorAll(selectors);
    images.forEach((img) => {
      if (img.loading === 'lazy') img.loading = 'eager';
    });
    return Promise.all([...images].map(decodeImage));
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      preloadHomepageImages().catch(() => {});
    });
  } else {
    preloadHomepageImages().catch(() => {});
  }
})();
